import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons'
import apiCall from "../../helpers/api";
import t from "../../helpers/translator";
import { login } from "../../store/actions";

const Logoff = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const auth = useSelector(state => state.user);


  const handleLogoff = () => {
    //close sidebar if open
    //closeSidebar(); 
    // Handle logoff logic here
    apiCall({ action: "login_logoff", token: auth.token })
      .then((response) => {
        if (parseInt(response.error) === 0 || parseInt(response.error) === 99) {
          // Store token, user_type and email in redux store
          dispatch(login("", "", "", null));
          // Redirect to home
          navigate("/");
        }
      })
      .catch((error) => {
        alert(t("Something went wrong. Please try again later...."));
      });
  };

  return (
    <>
    {
        auth.user_type !== '' ?
            <span onClick={(e) => handleLogoff()} style={{}}>
                <FontAwesomeIcon icon={faSignOutAlt} /> {t("Sign out")}
            </span>
            : null
    }
    </>
    )
}

export default Logoff;
